import { push, replace, getLocation } from 'connected-react-router';
import { get, find } from 'lodash';
import api from 'config/api';
import config from 'config';
import { profileActions } from 'store/profile';
import { pagesActions } from 'store/pages';
import requester, { subscribeToErrorResponse } from 'utils/requester';
import { getToken, setToken, clearToken } from 'utils/auth-token';
import { loadMenuItems } from './api';

import {
  ENABLE_MOUSE_CONTROLS,
  INIT_USER_DATA,
  INIT_USER_DATA_SUCCESS,
  INIT_USER_DATA_ERROR,
  SET_MENU_ITEMS,
} from './action-types';
import { appSelectors } from '.';

// actions
export const enableMouseControls = (mouseControlsEnabled) => ({
  type: ENABLE_MOUSE_CONTROLS,
  payload: { mouseControlsEnabled },
});

export const initUserData = () => async (dispatch) => {
  try {
    dispatch({ type: INIT_USER_DATA });

    subscribeToErrorResponse((error) => {
      if (get(error.response, ['status']) === 401) {
        clearToken();
        // reload with no token will emit "fetchGuestAuthToken"
        // window.location.hash = '';
        // window.location.reload();
      }
      throw error;
    });

    await dispatch(getAppConfig());

    const { value, isGuest } = getToken();
    const isUserLoggedIn = value && !isGuest;

    if (isUserLoggedIn) {
      await dispatch(profileActions.loginUserSuccess());
      await dispatch(profileActions.loadProfileData());
    } else if (!value) {
      await dispatch(fetchGuestAuthToken());
    }

    await dispatch(redirectToStartPage());

    dispatch({ type: INIT_USER_DATA_SUCCESS });
  } catch (error) {
    console.error(error);
    dispatch({ type: INIT_USER_DATA_ERROR });
  }
};

export const resetAllData = () => (dispatch) => {
  dispatch(pagesActions.resetData());
  dispatch(profileActions.resetData());
};

export const goToLoginPage = () => (dispatch) => {
  dispatch(push('login'));
};

export const fetchGuestAuthToken = () => async (dispatch) => {
  try {
    const dataJson = {
      grant_type: 'client_credentials',
      device_id: 'guest',
      client_id: config.client_id,
    };
    let dataToPOST = '';

    for (const [key, value] of Object.entries(dataJson)) {
      dataToPOST += `${key}=${value}&`;
    }

    const { data: authToken } = await requester({
      method: 'post',
      url: `${api.host}${api.endpoints.authorize}`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      data: dataToPOST,
    });

    setToken(authToken, true);
  } catch (error) {
    console.error(error);
    dispatch(push('technical-stub'));
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const resolveBannerNavigation = (payload = {} as any) => async (dispatch) => {
  const { url = '' } = payload;
  // url looks like 'asset://12345'
  const assetId = url.replace('asset://', '');

  try {
    if (!assetId) throw new Error('Unknown item!');

    const { data } = await requester({
      method: 'get',
      url: `${api.host}${api.endpoints.assets}/${assetId}`,
    });

    if (data.type === 'channel') {
      dispatch(push(`/player/${data.type}/${data.id}`));
    } else {
      dispatch(push(`/details/${data.type}/${data.id}`));
    }
  } catch (error) {
    console.error(error);
  }
};

export const getAppConfig = () => async (dispatch) => {
  try {
    const payload = await loadMenuItems();
    dispatch({ type: SET_MENU_ITEMS, payload });
  } catch (error) {
    console.error(error);
  }
};

export const redirectToStartPage = () => async (dispatch, getState) => {
  try {
    const location = getLocation(getState());
    const menuItems = appSelectors.selectMenuItems(getState());
    const homePage = find(menuItems, { type: 'home' });

    if (location.pathname === '/' && homePage) {
      dispatch(replace(homePage.path));
    }
  } catch (error) {
    console.error(error);
  }
};
